<article>
  <div
    class="content"
    [style.background-color]="backgroundColor"
    [style.background-image]="backgroundImageUrl()"
    (click)="goToAuthor(name)"
  >
    <div class="additional-data-container">
      <ng-content></ng-content>
    </div>

    <span>{{ name }}</span>
  </div>
</article>
